import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ApiService } from 'src/app/services/api/api.service';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-redemption-status',
  templateUrl: './modal-redemption-status.component.html',
  styleUrls: ['./modal-redemption-status.component.scss']
})
export class ModalRedemptionStatusComponent implements OnInit {

  @ViewChild('redemptionStatusModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-lg', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  status = '';
  item: any = {};
  rewardItem: any = {};
  myProfile: any = {};
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private utility: UtilitysService
  ) { }

  ngOnInit() {
    this.modalServ.onRedemptionStatus.subscribe(req => {
      console.log(req.status);
      this.status = req.status;
      this.item = req.item;
      this.getMyProfile();
      this.getReward();
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onRedemptionStatusHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyProfile() {
    this.myProfile = await this.utility.getMyProfile();
  }

  cancel() {
    this.hide();
    this.modalServ.onRedeemCancel.emit({reward: this.item});
  }

  async getReward(){
    this.rewardItem = await this.getRewardById(this.item.RewardID);
  }

  getRewardById(rewardId: any): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.getRewardById(rewardId).subscribe(res => {
        if(res.Code == 200) {
          resolve(res.Results);
        } else {
          console.error(res);
          resolve();
        }
      }, err => {
        console.error(err);
        resolve();
      });
    });
  }

}
